// extracted by css-extract-rspack-plugin
export default {"footer":"_KN8_","illustration":"rUSIR"};